import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

const MenuContext = createContext({
  showMenu: false,
  toggleMenu: () => { },
});

export const MenuConsumer = MenuContext.Consumer;

export default function MenuProvider({ children }) {
  const [showMenu, setValue] = useState(false);
  const toggleMenu = () => {
    setValue(!showMenu);
    if (!showMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  return (
    <MenuContext.Provider
      value={{
        showMenu,
        toggleMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}

MenuProvider.propTypes = { children: PropTypes.node.isRequired };
